import {QUESTION_TYPES} from './actionTypes';

type action = {
    type: string;
    payload: string;
};

/**
 * Bascially one page (screen) one reducer (store).
 * if something need to share across pages, we can create some reducers under reducers folder
 */
const reducer = (
    state = {
        test_str: '',
        question_index: 0,
        question_conf: {},
        list: {},
        answers: {},
    },
    {type, payload}: action,
) => {
    switch (type) {
        case QUESTION_TYPES.UPDATE_INDEX:
            return {
                ...state,
                question_index: payload,
            };

        case QUESTION_TYPES.UPDATE_LIST:
            return {
                ...state,
                list: payload,
            };
        case QUESTION_TYPES.UPDATE_ANSWERS:
            return {
                ...state,
                answers: payload
            }
        case QUESTION_TYPES.UPDATE_CONF:
            return {
                ...state,
                question_conf: payload
            }
        default:
            return state;
    }
};

export default reducer;
